/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurLocalisationContratGridDto } from './FcbFormateurLocalisationContratGridDto';
import {
    FcbFormateurLocalisationContratGridDtoFromJSON,
    FcbFormateurLocalisationContratGridDtoFromJSONTyped,
    FcbFormateurLocalisationContratGridDtoToJSON,
} from './FcbFormateurLocalisationContratGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormateurLocalisationContratGridDtoPaginatedResults
 */
export interface FcbFormateurLocalisationContratGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormateurLocalisationContratGridDto>}
     * @memberof FcbFormateurLocalisationContratGridDtoPaginatedResults
     */
    results?: Array<FcbFormateurLocalisationContratGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormateurLocalisationContratGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormateurLocalisationContratGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormateurLocalisationContratGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurLocalisationContratGridDtoPaginatedResultsFromJSON(json: any): FcbFormateurLocalisationContratGridDtoPaginatedResults {
    return FcbFormateurLocalisationContratGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormateurLocalisationContratGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurLocalisationContratGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormateurLocalisationContratGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormateurLocalisationContratGridDtoPaginatedResultsToJSON(value?: FcbFormateurLocalisationContratGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormateurLocalisationContratGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

